'use strict';

var styled = require('styled-components');
var header = require('./header.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const HeaderPillStyled = styled__default.default(header.Header) `
  padding-left: 0;

  & > div {
    justify-content: center;
    padding: 0;
  }
`;

exports.HeaderPillStyled = HeaderPillStyled;
//# sourceMappingURL=headerIcon.styles.js.map
